var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobshowered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 15 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: url(#linear-gradient);\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0,
    y1: 7,
    x2: 15,
    y2: 7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3aecfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4564ea"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.28,7.38h-.78v-3.06c0-.84.7-1.53,1.56-1.53h3.11M1.28,7.38v4.59c0,.84.7,1.53,1.56,1.53h9.33c.86,0,1.56-.68,1.56-1.53v-4.59M1.28,7.38h4.67M5.17,2.79v-.76c0-.84.7-1.53,1.56-1.53h1.56c.86,0,1.56.68,1.56,1.53v.76M5.17,2.79h4.67M13.72,7.38h.78v-3.06c0-.84-.7-1.53-1.56-1.53h-3.11M13.72,7.38h-4.67M5.94,7.38v-1.53h3.11v1.53M5.94,7.38v1.53h3.11v-1.53"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobshowered);
export default __webpack_public_path__ + "static/media/Jobs howered.13ea8d0f7dfeab8869e8539d644ca463.svg";
export { ForwardRef as ReactComponent };